<template>
  <div class="view view__intro">
    <ui-headline v-if="headline" :record="headline"/>
    <div v-if="body" class="view__body-container" :style="style">
      <div class="view__body" :style="{ 'background-color': body.textBackroundColor, 'border-color': body.textBorderColor }">
        <p v-if="body.quest"
            class="view__intro-description"
            v-html="body.quest"
        ></p>
        <img v-if="body.questImage" :src="body.questImage" class="view__intro-image"/>
      </div>
    </div>
    <ui-footer v-if="footer" :record="footer"/>
  </div>
</template>
<script>
import { StyleMixin, TimeMixin } from '@/mixins';
import UiHeadline from '@/components/ui-headline/index.vue';
import UiFooter from '@/components/ui-footer/index.vue';

export default {
  components: {
    UiHeadline,
    UiFooter,
  },
  mixins: [
    StyleMixin,
    TimeMixin,
  ],
  props: {
    record: Object,
  },
  data() {
    const { headline, body, footer } = this.record;

    return {
      headline,
      body,
      footer,
    };
  },
};
</script>
